// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__BywRr","setting":"styles_setting__sgzHE","center":"styles_center__RB6ud","top":"styles_top__-R3-m"};